// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  getMyTripsBusPending: false,
  getMyTripsBusError: null,
  myTripsBus:null,
  poolTrips:null,
  myAtTrips: null,
  kuposGoTrips: null,
  myTripsTrain: null,
  getMyTransactionsPending: false,
  getMyTransactionsError: null,
  myTransactions: null,
  getVirtualMoneyPending: false,
  getVirtualMoneyError: null,
  myVirtualMoney: null,
  walletRechargePending: false,
  walletRechargeError: null,
  getRechargeLocationsPending: false,
  getRechargeLocationsError: null,
  getCustomerInfoPending: false,
  getCustomerInfoError: null,
  updateFavouritesPending: false,
  updateFavouritesError: null,
  favourites: null,
  getProfilePending: false,
  getProfileError: null,
  transferMoneyPending: false,
  transferMoneyError: null,
  getQrPending: false,
  getQrError: null,
  qrImage: null,
  getPoolTripsPending: false,
  getPoolTripsError: null,
  getKuposGoTripsPending: false,
  getKuposGoTripsError: null,
  getMyAtTripsPending: false,
  getMyAtTripsError: null,
  getMyTrainTripsPending: false,
  getMyTrainTripsError: null,
  addBipCardPending: false,
  addBipCardError: null,
  apiCallPending: false,
  apiCallError: null
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/my-account/redux/initialState.js